import { Spinner } from '@nocowanie/common-ui/components/atoms/spinner';

export const MapSpinner = () => {
    return (
        <Spinner
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            zIndex={'overMapMarkers'}
            bg="rgba(255, 255, 255, 0.95)"
            p={1}
            borderRadius="full"
            boxShadow="xs"
            pointerEvents="none"
        />
    );
};
